{
  "metadata": {
    "id": "carbonfox-dark",
    "name": "Carbonfox",
    "description": "Портировано из темы «Carbonfox» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "carbonfox.json",
      "project": "EdenEast",
      "url": "https://github.com/EdenEast/nightfox.nvim",
      "upstreamFile": "packages/ui/src/theme/themes/carbonfox.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.3,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.461,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.0,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.4,
      "syntaxVsTextMinDeltaE": 20.0,
      "chartsMinDeltaE": 46.5,
      "textSeparationDeltaE": 15.0,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#33b1ff",
      "hover": "#4bbaff",
      "active": "#5cc1ff",
      "foreground": "#000000",
      "muted": "#33b1ff80",
      "emphasis": "#33b1ff"
    },
    "surface": {
      "background": "#393939",
      "foreground": "#f2f4f8",
      "muted": "#4b4c4c",
      "mutedForeground": "#c8cacb",
      "elevated": "#555556",
      "elevatedForeground": "#f2f4f8",
      "raised": "#69696a",
      "raisedForeground": "#f2f4f8",
      "overlay": "#393939cc",
      "subtle": "#424242"
    },
    "interactive": {
      "border": "#6f7071",
      "borderHover": "#6d6d6e",
      "borderFocus": "#33b1ff",
      "selection": "#f2f4f829",
      "selectionForeground": "#f2f4f8",
      "focus": "#33b1ff59",
      "focusRing": "#33b1ff61",
      "cursor": "#f2f4f8",
      "hover": "#f2f4f81c",
      "active": "#f2f4f829"
    },
    "status": {
      "error": "#ff8389",
      "errorForeground": "#000000",
      "errorBackground": "#ff838924",
      "errorBorder": "#ff838973",
      "warning": "#f1c21b",
      "warningForeground": "#000000",
      "warningBackground": "#f1c21b24",
      "warningBorder": "#f1c21b73",
      "success": "#42be65",
      "successForeground": "#000000",
      "successBackground": "#42be6524",
      "successBorder": "#42be6573",
      "info": "#78a9ff",
      "infoForeground": "#000000",
      "infoBackground": "#78a9ff24",
      "infoBorder": "#78a9ff73"
    },
    "pr": {
      "open": "#42be65",
      "draft": "#d8d9da",
      "blocked": "#f1c21b",
      "merged": "#ff8389",
      "closed": "#ff8389"
    },
    "syntax": {
      "base": {
        "background": "#5f5f60",
        "foreground": "#f2f4f8",
        "comment": "#eee3c4",
        "keyword": "#f7ceff",
        "string": "#b4e5c2",
        "number": "#ffd0d2",
        "function": "#c5daff",
        "variable": "#f2f4f8",
        "type": "#f6d768",
        "operator": "#ffffff"
      },
      "tokens": {
        "commentDoc": "#eee3c4",
        "stringEscape": "#ffffff",
        "keywordImport": "#f7ceff",
        "storageModifier": "#f7ceff",
        "functionCall": "#c5daff",
        "method": "#c5daff",
        "variableProperty": "#c5daff",
        "variableOther": "#f2f4f8",
        "variableGlobal": "#ffd0d2",
        "variableLocal": "#ffffff",
        "parameter": "#f2f4f8",
        "constant": "#ffd0d2",
        "class": "#f6d768",
        "className": "#f6d768",
        "interface": "#f6d768",
        "struct": "#f6d768",
        "enum": "#f6d768",
        "typeParameter": "#f6d768",
        "namespace": "#f6d768",
        "module": "#f7ceff",
        "tag": "#f7ceff",
        "jsxTag": "#f7ceff",
        "tagAttribute": "#c5daff",
        "tagAttributeValue": "#b4e5c2",
        "boolean": "#ffd0d2",
        "decorator": "#f7ceff",
        "label": "#c5daff",
        "regexp": "#b4e5c2"
      }
    },
    "charts": {
      "series": [
        "#33b1ff",
        "#787cff",
        "#42be65",
        "#f1c21b",
        "#ff8389"
      ]
    },
    "chat": {
      "background": "#393939",
      "userMessage": "#f9fafc",
      "userMessageBackground": "#555556",
      "assistantMessage": "#f2f4f8",
      "assistantMessageBackground": "#4b4c4c",
      "timestamp": "#d8d9da",
      "divider": "#6f7071",
      "typing": "#d8d9da"
    },
    "loading": {
      "spinner": "#33b1ff",
      "spinnerTrack": "#4b4c4c",
      "skeleton": "#4b4c4c",
      "shimmer": "#686869"
    },
    "tools": {
      "background": "#4b4c4c",
      "border": "#6f7071",
      "headerHover": "#666668",
      "icon": "#52bdff",
      "title": "#f2f4f8",
      "description": "#d8d9da",
      "edit": {
        "added": "#42be65",
        "addedBackground": "#42be6524",
        "removed": "#ff8389",
        "removedBackground": "#ff838924",
        "modified": "#78a9ff",
        "modifiedBackground": "#78a9ff24",
        "lineNumber": "#d8d9da"
      }
    },
    "markdown": {
      "heading1": "#f2f4f8",
      "heading2": "#f2f4f8",
      "heading3": "#f2f4f8",
      "heading4": "#f2f4f8",
      "link": "#33b1ff",
      "linkHover": "#4bbaff",
      "inlineCode": "#b4e5c2",
      "inlineCodeBackground": "#4b4c4c",
      "blockquote": "#d8d9da",
      "blockquoteBorder": "#6f7071",
      "listMarker": "#33b1ffbf",
      "bold": "#f2f4f8",
      "italic": "#f2f4f8e6",
      "strikethrough": "#d8d9da",
      "hr": "#6f7071"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#be4541",
        "foreground": "#ffffff",
        "contrast": 5.1
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#bd7e5b",
        "foreground": "#000000",
        "contrast": 6.3
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#e1c8a5",
        "foreground": "#000000",
        "contrast": 13.01
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c2bd65",
        "foreground": "#000000",
        "contrast": 10.76
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#8ac652",
        "foreground": "#000000",
        "contrast": 10.28
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#b4e3a7",
        "foreground": "#000000",
        "contrast": 14.49
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#54c57b",
        "foreground": "#000000",
        "contrast": 9.65
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#59bb9e",
        "foreground": "#000000",
        "contrast": 9.03
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#abd7dd",
        "foreground": "#000000",
        "contrast": 13.5
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4c9fc1",
        "foreground": "#000000",
        "contrast": 7.04
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#465fb1",
        "foreground": "#ffffff",
        "contrast": 5.95
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#aba6d9",
        "foreground": "#000000",
        "contrast": 9.19
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8944bb",
        "foreground": "#ffffff",
        "contrast": 5.82
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c784cc",
        "foreground": "#000000",
        "contrast": 7.6
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c048a9",
        "foreground": "#000000",
        "contrast": 4.74
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#dfa2b4",
        "foreground": "#000000",
        "contrast": 9.96
      }
    ]
  }
}
